import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const processEvaluationsStyle: StyleRulesCallback = () => ({
  root: {},
});

export default processEvaluationsStyle;
